/**
 * Сопоставление распознанной с фото накладной со справочниками.
 * Тот же принцип, что в мобилке (flutter_mison/lib/pages/director/documents_in/create.dart)
 * и на бэке при поиске похожих приходов — иначе веб и телефон подставляли бы разные элементы.
 */

/** Организационные формы только мешают сравнению названий. */
const ORGANIZATION_FORMS = ['ооо', 'оао', 'зао', 'ип', 'чп', 'мчж', 'xk', 'ok', 'llc', 'ltd']

/** Порог совпадения для поставщика — юр. название на бумаге длиннее заведённого в базе. */
export const SUPPLIER_MATCH_THRESHOLD = 0.5
/** Порог для позиций — тут ошибка дороже, поэтому строже. */
export const ELEMENT_MATCH_THRESHOLD = 0.62

function normalizeName(value) {
	return String(value ?? '')
		.toLowerCase()
		.replace(/[^\p{L}\p{N}]+/gu, ' ')
		.split(' ')
		.filter(word => word && !ORGANIZATION_FORMS.includes(word))
		.join(' ')
}

/** 0..1 — насколько похожи два наименования. */
export function nameSimilarity(first, second) {
	const a = normalizeName(first)
	const b = normalizeName(second)

	if (!a || !b) return 0
	if (a === b) return 1
	if (a.includes(b) || b.includes(a)) return 0.9

	const aWords = new Set(a.split(' '))
	const bWords = new Set(b.split(' '))
	var common = 0
	aWords.forEach(word => { if (bWords.has(word)) common++ })
	if (common === 0) return 0

	return common / (aWords.size + bWords.size - common)
}

/** Самый похожий вариант из списка или null, если ничего не дотянуло до порога. */
export function bestMatch(name, options = [], threshold = ELEMENT_MATCH_THRESHOLD) {
	var best = null
	var bestScore = 0

	for (let i = 0; i < options.length; i++) {
		const score = nameSimilarity(name, options[i]['name'])
		if (score > bestScore) {
			bestScore = score
			best = options[i]
		}
	}

	return bestScore >= threshold ? best : null
}
